import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';

@Component({
    selector: 'app-bookmarks-link-card',
    templateUrl: './bookmarks-link-card.component.html',
    standalone: false
})
export class BookmarksLinkCardComponent {
    @Input() label: string = '';
    @Input() tab: string = '';

    constructor(
        private userService: UserService,
        private router: Router
    ) {}

    navigate() {
        if (this.userService.isLoggedIn) {
            this.router.navigate(['/account/bookmarks'], {queryParams: {tab: this.tab}});
        } else {
            this.router.navigate(['/login']);
        }
    }
}
